<script lang="ts">
  import {
    AdminViewFrame as ControlAdminViewFrame,
    type AdminViewFrameContext,
  } from "@kontextwerk/control-web-frame"
  import KehrblattOrganizationsPage from "./kehrblatt-organizations"
</script>

{#snippet organizationsPage({
  viewFrameContext,
  activeTab,
}: {
  viewFrameContext: AdminViewFrameContext
  activeTab: string
})}
  <KehrblattOrganizationsPage {viewFrameContext} {activeTab} />
{/snippet}

<ControlAdminViewFrame {organizationsPage} />
